import script from "./NotificationPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPage.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationPage.vue?vue&type=style&index=0&id=d6fee804&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6fee804"]])

export default __exports__